import { ReapproAlgorithm } from '@gozoki/api-types';
import { useForm } from 'react-hook-form';

export type ReapproAlgorithmsFormValues = {
    algorithms: Record<string, ReapproAlgorithm>;
};

export const useReapproAlgorithmMatrixForm = () => {
    return useForm<ReapproAlgorithmsFormValues>({
        defaultValues: { algorithms: {} },
    });
};
